import { Monthly10k } from '@daymade/common-lib/constants';
import { CONFIRMATION_ASSET_FOLDER } from 'constants/Confirmation';
import Link from 'next/link';

export const PERKS = [
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/win-with-friends.svg`,
    header: 'Win with friends',
    description: (
      <>
        You can now{' '}
        <Link href={'/referrals'} className="textDecorationUnderline">
          invite your friends
        </Link>{' '}
        & win rewards worth up to £5k whenever they win a prize in our weekly
        draws!
      </>
    ),
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/monthly.svg`,
    header: 'Monthly £10K Giveaway',
    description: (
      <>
        Earn entries into this epic{' '}
        <Link href={Monthly10k.urlPath} className="textDecorationUnderline">
          subscribers only raffle
        </Link>{' '}
        every week you're subscribed
      </>
    ),
    test: true,
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/discounts.svg`,
    header: 'Epic Discounts',
    description: (
      <>
        From companies like Virgin <br /> Experience Days. Wild deodorant &{' '}
        <Link href="/my-discounts" className="textDecorationUnderline">
          more
        </Link>
      </>
    ),
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/games.svg`,
    header: 'Exclusive Games',
    description: (
      <>
        Awesome draws and raffles <br /> down in{' '}
        <Link href="/token-town" className="textDecorationUnderline">
          Token Town
        </Link>
      </>
    ),
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/give-back.svg`,
    header: 'A tree a week',
    description: (
      <>
        You’ll plant a tree <br /> every week with{' '}
        <Link
          href="https://www.veritree.com/"
          className="textDecorationUnderline"
          target="_blank"
          rel="noopener noreferrer"
        >
          veritree
        </Link>
      </>
    ),
  },
];

export const filterPerksByTestGroup = (isInMonthlyTestGroup: boolean) => {
  return PERKS.filter((perk) => !perk.test || isInMonthlyTestGroup);
};
